import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import NFTs from "../_metadata.json";
import about1 from "../assets/1843.png";
import about2 from "../assets/2903.png";
import about7 from "../assets/2331.png";
import about3 from "../assets/1170.png";
import about4 from "../assets/1573.png";
import about6 from "../assets/2640.png";

function Nfts() {
  return (
    <section
      className="container about_container"
      id="about"
      style={{
        marginTop: "11rem",
      }}
    >
      <div
        className="image_slides"
        style={{
          display: "block",
        }}
      >
        <img
          src={about1}
          className="big_img"
          style={{
            width: "100%",
            borderRadius: "40px",
          }}
        />
      </div>
      <div className=" about_text">
        <div className="about_text_header">
          <h2
            style={{
              lineHeight: "62px",
              fontSize: "48px",
              textAlign: "center",
              marginTop: "110px",
            }}
          >
            {" "}
            MonkeyDoo 🐵
            <br /> Marketplace Coming Soon
          </h2>
        </div>
        <div className="about_text_main">
          <h5>
            As stated in our Roadmap, we have commense the building of Our NFT
            marketplace and it will be launch right after the NFT Project is
            sold out
            <br />
            <br />{" "}
          </h5>
        </div>
        <div
          style={{
            textAlign: "center",
          }}
        >
          <a
            href="/#minter"
            className="btn btn-primary"
            style={{
              height: "initial",
            }}
          >
            Mint MonkeyDoo NFT !
          </a>
        </div>
      </div>
    </section>
  );
}

export default Nfts;
